import config from 'config';
import React from 'react';
import styled from 'styled-components';

import { LogoIcon } from 'components/Icons/LogoIcon';
import theme from 'theme/theme';

const CURR_YEAR = new Date().getFullYear();

const AffiliateFooter = () => {
  return (
    <Container>
      <LogoIcon width={70} height={44} fill={theme.colors.white} />
      <Copyright>Copyright © {CURR_YEAR} Shido Group Ltd.</Copyright>
      <Links>
        <Link
          href={`${config.shidoWebsiteVersion}/terms-and-conditions`}
          target="_blank"
          rel="noreferrer"
        >
          Terms & Conditions
        </Link>
        <Link
          href={`${config.shidoWebsiteVersion}/privacy-policy`}
          target="_blank"
          rel="noreferrer"
        >
          Privacy policy
        </Link>
      </Links>
    </Container>
  );
};

const Container = styled.footer`
  position: relative;
  background-color: ${({ theme }) => theme.colors.topicBlue};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 78px 20px 200px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 34px 20px 100px;
  }
`;

const Copyright = styled.p`
  margin: 44px 0 0;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;

  ${({ theme }) => theme.breakpoints.down('md')} {
    margin-top: 24px;
    font-size: 14px;
  }
`;

const Links = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 24px;
  margin-top: 16px;
`;

const Link = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.8;
  text-decoration: underline;

  &:hover {
    opacity: 1;
  }
`;

export default AffiliateFooter;
